// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d8e848ac","172":"d96a73a3","203":"790e1234","372":"cec58960","407":"0842f755","464":"a9e7d6ef","483":"4637d245"}[chunkId] + ".chunk.js";
};